import React from 'react';
import { Link } from 'react-router-dom';
import './HomeComponents.css';

function CategoryBrowser({ categories }) {
  return (
    <div className="category-browser">
      <div className="categories-grid">
        {categories.map(category => (
          <Link 
            to={`/browse?category=${encodeURIComponent(category.name)}`} 
            key={category.id} 
            className="category-card"
          >
            <div className="category-icon">{category.icon}</div>
            <div className="category-name">{category.name}</div>
          </Link>
        ))}
      </div>
    </div>
  );
}

export default CategoryBrowser; 